import { firestore } from './firebase';
import * as utils from './utils.js';

export const PROVIDERS = {
    md: 'Medical Doctor',
    do: 'Doctor of Osteopathic Medicine',
    ch: 'Chiropractor',
    pt: 'Physical Therapist',
    nurse: 'Nurse',
    np: 'Nurse Practitioner',
    rn: 'Registered Nurse',
    pa: 'Physician Assistant',
    rep: 'Medical Device Rep/Exec',
    st: 'ScrubTech / Other Technician',
    med: 'Med or Pre-Med Student',
    bil: 'Medical Billing / Coder',
    oth: 'Other'
}


// helper to look up a particular document from a particular collection by its
// primary ID, returning it as an object with its .id member set, or null if not
// found.
export function GetDoc(collectionName, docID)
{
    return new Promise((resolve, reject) =>
    {
        firestore.collection(collectionName).doc(docID).get().then(doc =>
        {
            let ret = null;
            if (doc.exists)
            {
                ret = doc.data();
                ret.id = doc.id;
                resolve(ret);
            }
            else
            {
                reject('document not found', collectionName, docID);
            }
        });
    });
}

/*
db.collection("cities").doc("SF")
    .onSnapshot(function(doc) {
        console.log("Current data: ", doc.data());
    });
*/












